//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatTime,guid,dateFormat} from "@/utils/common";
import {monthListData} from '@/api/flyback/flyback';
import {BASIC} from "@/config/constant";
import promise from '@/axios/promise';
import { Toast } from 'mint-ui';

export default{
    name :'flybackApply',
    data(){
        return {
            calDate:this.$route.query.calDate,
            // 月份天数
            mDays:'',
            week:'',
            starDay:'',
            endDay:"",
            year:'',
            month:0,
            index:'',
            // 选中日期的flyback申请数据
            dataList:[],
            data:{
               // 月份所有的flyback申请数据
               flybackApprList:[],
               // 选中日期的申请数据
               dayApplyData:[],
               // 月份所有的日报填写信息
               dayReportList:[]
            },
        }
    },
    created(){

    },
    mounted(){
        var data= new Date();
        if(this.calDate!=null && this.calDate!=undefined){
            data=new Date(this.calDate);
        }
        var year =data.getFullYear();
        var month=data.getMonth()+1;
        var day=data.getDate();
        this.year=year;
        this.month=month;
        this.index=day;
        this.dateRech(this.year,this.month);
    },
    methods:{
        //时间格式化
        dateFormatter(date) {
            return dateFormat(date);
        },
        //返回
        goBack(){
            //this.$router.push({path:'/'});
            this.$router.go(-1);
        },
        // 选中月份及选中日期的数据获取
        dateRech(year,month){
            // 获取月份的天数
            var dayNum=this.mGetDate(year,month);
            this.mDays=dayNum;
            // 防止月份没有那么大的日期
            if(this.index>dayNum){
                this.index = dayNum;
            }
            //当前月当天日期对象：
            var starDate=new Date(year, month, 0);
            //当前月第一天日期对象：
            starDate=new Date(starDate.setDate(1));
            //当前月第一天星期几:
            var weekday=starDate.getDay();
            this.starDay=weekday;
            this.dataList=[];
            // 获取选中月份的flyback申请数据
            this.getFlybackApplyByMonth();
            var total =42-parseInt(dayNum)-parseInt(weekday);
            if(total>=7){
                this.endDay=total-7;
            }else{
                this.endDay=total;
            }
        },
        //所在月份的数据
        getFlybackApplyByMonth(){
            // 选中的月份
            var monthStr=""+this.month;
            if(this.month<10){
                monthStr="0"+monthStr;
            }

            // 年月
            var ym = this.year+'-'+monthStr;

            // 获取选中月份所有的flyback申请数据
            var condition = {'condition':{'applyMonth':ym}};
            monthListData(condition).then(response => {
                // 获取本月所有的flyback申请数据
                this.data.flybackApprList=response.list;

                // 获取月份中的日报数据
                promise({
                    url:BASIC+'/dayReport/list/month',
                    method:'get',
                    params:{month:ym}
                }).then(res=>{
                    if(res.code==0){
                        this.data.dayReportList=res.data;

                        // 更新日期中存在flyback申请、日报的显示
                        this.updateDateList();
                        // 获取选中日期的flyback申请数据
                        this.getInfo(this.index);
                    }
                });
            });
        },
        // 处理本月份存在flyback申请、日报的显示
        updateDateList(){
            var maxDay=this.mDays;
            this.dataList=[];
            // 当前日期
            var currDate=new Date();
            for(var i=1;i<=maxDay;i++){
                // flyback申请、日报数据
                var applyDataItem = {};
                // 日期
                applyDataItem.dateDay = i;

                var dayStr=i+"";
                if(i<10){
                    dayStr="0"+dayStr;
                }
                var monthStr=""+this.month;
                if(this.month<10){
                    monthStr="0"+monthStr;
                }
                var date=this.year+'-'+monthStr+'-'+dayStr;

                // ********flyback申请数据处理***************
                var flybackApplys = [];
                this.data.flybackApprList.find((item) => {
                    //筛选出匹配数据
                    if(item.fbDate === date){
                        flybackApplys.push(item);
                    }
                });
                var statusClass="unReach";
                applyDataItem.applyData = [];
                if(flybackApplys!=null && flybackApplys!=undefined && flybackApplys.length>0){
                    flybackApplys.forEach(element => {
                        // flyback申请数据
                        var applyData={};
                        var status=element.status;
                        if(status=='被驳回'){
                            statusClass="refused";
                        }
                        if(status=='待审批'){
                            statusClass="wait";
                        }
                        if(status=='已通过'){
                            statusClass="success";
                        }
                        // 状态样式
                        applyData.statusClass=statusClass;
                        // 单边费用
                        applyData.perCost=element.perCost;
                        // 类型：申请、折现
                        applyData.flybackType=element.flybackType;
                        // 申请的往返类型
                        var applyType = "";
                        // 折现金额
                        var discountAmt = 0;
                        if(element.flybackType === '申请'){
                            applyType = element.fbType;
                        }else{
                            // 折现情况下
                            discountAmt = element.discountAmt;
                        }
                        // 申请往返类型
                        applyData.applyType = applyType;
                        // 折现金额
                        applyData.discountAmt = discountAmt;

                        applyDataItem.applyData.push(applyData);
                    });
                }

                // ******************日报数据处理 *******************
                // 工时
                var workHour=0;
                // 人天补助
                var workSubsidy=0;
                var status="已通过";
                // 日报统计数据
                var reportData={};
                var dayReport = this.data.dayReportList.find((item) => { //这里的userList就是上面遍历的数据源
                    var reportTime=new Date(item.reportTime) ;
                    return formatTime(reportTime,'yyyy-MM-dd') == date; //筛选出匹配数据
                });
                applyDataItem.dayReportData = [];
                if(dayReport!=null && dayReport!=undefined){
                    var refuseFlag=false;
                    var waitFlag=false;
                    dayReport.reportDetailList.forEach(element => {
                       workHour+=element.workHour;
                       workSubsidy+=element.workSubsidy; 
                       var status=element.status;
                       if(status=='被驳回'){
                            refuseFlag=true;
                       }
                       if(status=='待审批'){
                           waitFlag=true;
                       }
                    });
                    if(refuseFlag){
                        status="被驳回";
                        statusClass="refused";
                    }else if(waitFlag && !refuseFlag){
                        status="待审核";
                        statusClass="wait";
                    }else{
                        status="已通过";
                        statusClass="success";
                    }

                    reportData.statusClass=statusClass;
                    reportData.workHour=workHour;
                    reportData.workSubsidy=workSubsidy;
                    // 添加日报统计数据
                    applyDataItem.dayReportData.push(reportData);
                }

                // 添加数据
                this.dataList.push(applyDataItem);
            }
        },
        //日历点击查看当天
        getInfo(index){
            this.index=index;
            var self=this;
            var dayStr=this.index+"";
            if(index<10){
                dayStr="0"+dayStr
            }
            var monthStr=""+this.month;
            if(this.month<10){
                monthStr="0"+monthStr
            }
            var date=this.year+'-'+monthStr+'-'+dayStr;
            this.data.dayApplyData=[];
            for(var i=0;i<this.data.flybackApprList.length;i++){
                var item = this.data.flybackApprList[i];
                if(item.fbDate === date){
                    this.data.dayApplyData.push(item);
                }
            }
        },
        // flyback 申请，1：申请 2：结算
        flybackApplyClick(type){

            // 判断是否已经存在申请或折现
            /*if(this.data.dayApplyData.length>0){
                Toast({
                  message: '已存在申请或折现，无法再次创建！',
                  position: 'middle',
                  duration: 1500,
                  className:'warning'
                });
                return;
            }*/

            var dayStr=this.index+"";
            if(this.index<10){
                dayStr="0"+dayStr;
            }
            var monthStr=""+this.month;
            if(this.month<10){
                monthStr="0"+monthStr;
            }
            var date=this.year+'-'+monthStr+'-'+dayStr;

            // flag: 1: 编辑 2：查看 0：创建
            this.$router.push({ name:'差旅明细',params:{flag:'0',mainId:'',type:type,applyDate:date,showRecord:'0',personCode:''}});
        },
        getClass(index){
            if(index==this.index){
                return "checkedDay";
            }
            return "";
        },
        // 明细处理
        modifyClick(row){
            var type = '';
            if(row.flybackType === '申请'){
                // 申请
                type = '1';
            }else{
                // 折现
                type = '2';
            }
            var flag = '2';
            if(row.status === '被驳回'){
                flag = '1';
            }

            // flag: 1: 编辑 2：查看 0：创建
            this.$router.push({ name:'差旅明细',params:{flag:flag,mainId:row.id,type:type,applyDate:row.applyDate,showRecord:'1',personCode:row.crtUserCode}});
        },
        // 获取月份的天数
        mGetDate(year, month){
            var d = new Date(year, month, 0);
            return d.getDate();
        },
        vueTouch:function(txt,e){
            if(txt=='左滑'){
                this.month+=1;
                if(this.month>12){
                    this.year+=1;
                    this.month=1;
                }
                this.dateRech(this.year,this.month);
            }else if(txt=='右滑'){
                this.month-=1;
                if(this.month<1){
                    this.year-=1;
                    this.month=12;
                }
                this.dateRech(this.year,this.month);
            }
        }
    },
    filters:{
        statusFilter(val){
            if(val=='已通过'){
                return 'successStatus';
            }
            if(val=='被驳回'){
                return 'refuseStatus';
            }
            if(val=='待审批'){
                return 'waitStatus';
            }
        },
        dateFilter(val){
            if(val==null || val==""){
                return "";
            }
            return formatTime(val,'yyyy年MM月dd日');
        },
        timeFilter(val){
            if(val==null || val==""){
                return "";
            }
            return formatTime(val,'hh:mm');
        },

    }
}



// WEBPACK FOOTER //
// ./src/view/flyback/flybackApply.vue